import { authGet, getData } from '../common'

export const getMenu = (account) => {
    return authGet({
        url: `/menu/user`,
        params: {
            account,
        },
    }).then(getData)
}
